/** Always-on subtle area-name label at the top of the sidebar. */
export class LevelLabelRenderer {
	private el: HTMLDivElement;
	private currentText: string = "";

	constructor(container: HTMLElement) {
		this.el = document.createElement("div");
		this.el.className = "level-label";
		container.appendChild(this.el);
		this.update(null);
	}

	update(areaName: string | null): void {
		const next = areaName ?? "";
		if (next === this.currentText) return;
		this.currentText = next;
		this.el.textContent = next;
		this.el.style.display = next ? "" : "none";
	}
}
